import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import DemoFormDialog from "@/components/DemoFormDialog";
import { BRAND } from "@/data/site";

/** Compact mid-page call to action: try it, see a demo, or keep exploring. */
export default function InlineCta({ text = "Ready to try it on your own WhatsApp number?", source = "inline", secondary = { to: "/features", label: "Explore all features" } }) {
  return (
    <div className="mt-12 flex flex-col md:flex-row md:items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-white p-5 sm:p-6">
      <p className="font-display text-lg font-semibold text-slate-900">{text}</p>
      <div className="flex flex-wrap items-center gap-3">
        <a href={`${BRAND.appUrl}/login`}>
          <Button className="bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full px-6 h-11 font-semibold">Start Free Trial <ArrowRight className="ml-2 w-4 h-4" /></Button>
        </a>
        <DemoFormDialog source={source} trigger={<Button variant="outline" className="rounded-full px-6 h-11 font-semibold">Book Free Demo</Button>} />
        {secondary && <Link to={secondary.to} className="text-sm font-semibold text-slate-700 hover:text-[#25D366]">{secondary.label} →</Link>}
      </div>
    </div>
  );
}
